
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { PorderLine } from './porder-line';
import { PorderDelivery } from './porder-delivery';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';


export class Porder extends BaseEntity {

  porderCode      : string;
  
  partner         : Partner = new Partner();
  person          : Person  = new Person();
  role            : Role    = new Role();

  theDate         : Date;
  returnPo        : boolean = false;
  closed          : boolean = false;

  porderLines     : PorderLine[];

  porderDeliveries: PorderDelivery[] ;

  constructor() {
    super();

  }
}

